import { create } from 'zustand'

export interface MemberData {
  userId: string
  displayName: string
  avatarUrl: string | null
  membership: string
  powerLevel: number
}

interface PresenceData {
  presence: 'online' | 'offline' | 'unavailable'
  lastActiveAgo?: number
  statusMsg?: string
}

interface MemberState {
  members: Map<string, MemberData[]>
  presence: Map<string, PresenceData>
  typing: Map<string, string[]>

  setMembers: (roomId: string, members: MemberData[]) => void
  updatePresence: (userId: string, data: PresenceData) => void
  setTyping: (roomId: string, userIds: string[]) => void
}

const EMPTY_MEMBERS: MemberData[] = []
const EMPTY_TYPING: string[] = []

export const useMemberStore = create<MemberState>((set) => ({
  members: new Map(),
  presence: new Map(),
  typing: new Map(),

  setMembers: (roomId, members) =>
    set((state) => {
      const map = new Map(state.members)
      map.set(roomId, members)
      return { members: map }
    }),

  updatePresence: (userId, data) =>
    set((state) => {
      const presence = new Map(state.presence)
      presence.set(userId, data)
      return { presence }
    }),

  setTyping: (roomId, userIds) =>
    set((state) => {
      const typing = new Map(state.typing)
      typing.set(roomId, userIds)
      return { typing }
    }),
}))

export function selectMembers(roomId: string) {
  return (s: MemberState) => s.members.get(roomId) ?? EMPTY_MEMBERS
}

export function selectPresence(userId: string) {
  return (s: MemberState) => s.presence.get(userId)
}

export function selectTyping(roomId: string) {
  return (s: MemberState) => s.typing.get(roomId) ?? EMPTY_TYPING
}
